import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { register as registerSwiper } from 'swiper/element/bundle';

import { AppModule } from 'src/app/ui/app.module';
import { environment } from 'src/environments/environment';

registerSwiper();

if (environment.production) {
  enableProdMode();
}

if (environment.analytics.segmentWriteKey) {
  // eslint-disable-next-line no-underscore-dangle
  (analytics as any)._writeKey = environment.analytics.segmentWriteKey;
  analytics.load(environment.analytics.segmentWriteKey);
}

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.log(err));
